<ng-container *ngIf="announcement">
    <div *ngIf="!compact" class="announcementCard" (click)="open()">
        <div class="announcementCardIcon">
            <fe-icon [iconType]="announcement.icon" [color]="ColorType.blue" [size]="20"/>
        </div>
        <div class="announcementCardBody">
            <span class="announcementCardTitle">{{announcement.title}}</span>
            <span class="announcementCardText">{{announcement.shortText}}</span>
            <span class="announcementCardLink">Découvrir l'option</span>
        </div>
        <mat-icon class="announcementCardClose" matTooltip="Masquer" (click)="dismiss($event)">close</mat-icon>
    </div>
    <div *ngIf="compact" class="announcementCardCompact" [title]="announcement.title" (click)="open()">
        <fe-icon [iconType]="announcement.icon" [color]="ColorType.blue" [size]="20"/>
    </div>
</ng-container>
